import React from "react";
import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";

import WorkareaView from "features/workarea/components/WorkareaView";
import OrganizationView from "features/organization/components/OrganizationView";
import CtdRouter from "features/ctd/CtdRouter";
import SoloRouter from "features/solo/SoloRouter";
import StatusView from "features/datatools/status/components/StatusView";
import DownloadView from "features/datatools/download/components/DownloadView";
import ReleaseNotes from "app/ReleaseNotes";
import ReleaseNotesEmail from "app/ReleaseNotesEmail";
import UploadView from "features/datatools/upload/components/UploadView";
import ElabBulkView from "features/elab/upload/components/ElabBulkView";
import LandingPage from "components/LandingPage";
import NotFound from "components/404";
import EditFormView from "features/datatools/download/components/EditFormView";

const Router = props => (
  <Switch>
    <Route exact path={`${props.match.url}/`} component={LandingPage} />
    <Route path={`${props.match.url}/workarea`} component={WorkareaView} />
    <Route
      path={`${props.match.url}/organization`}
      component={OrganizationView}
    />
    <Route path={`${props.match.url}/ctd`} component={CtdRouter} />
    <Route path={`${props.match.url}/solo`} component={SoloRouter} />
    <Route path={`${props.match.url}/status`} component={StatusView} />
    <Route path={`${props.match.url}/download`} component={DownloadView} />
    <Route path={`${props.match.url}/releases`} component={ReleaseNotes} />
    <Route
      path={`${props.match.url}/releases_email`}
      component={ReleaseNotesEmail}
    />
    <Route path={`${props.match.url}/upload`} component={UploadView} />
    <Route path={`${props.match.url}/elabupload`} component={ElabBulkView} />
    {props.adminAccess && (
      <Route path={`${props.match.url}/edit-form`} component={EditFormView} />
    )}
    <Route component={NotFound} />
  </Switch>
);

Router.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  adminAccess: PropTypes.bool.isRequired
};

export default Router;
